export default __webpack_public_path__ + "static/media/vector-right.5c83a72c.png";